export function StatTime({className, ...props}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 3C5.23858 3 3 5.23858 3 8C3 10.7614 5.23858 13 8 13C10.7614 13 13 10.7614 13 8C13 5.23858 10.7614 3 8 3ZM2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.8284 5.17184C11.0237 5.3671 11.0237 5.68368 10.8284 5.87894L8.35355 8.35382C8.15829 8.54908 7.84171 8.54908 7.64645 8.35382C7.45118 8.15856 7.45118 7.84197 7.64645 7.64671L10.1213 5.17184C10.3166 4.97658 10.6332 4.97658 10.8284 5.17184Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 0.5C6 0.223858 6.22386 0 6.5 0H9.5C9.77614 0 10 0.223858 10 0.5C10 0.776142 9.77614 1 9.5 1H6.5C6.22386 1 6 0.776142 6 0.5Z"
        fill="currentColor"
      />
    </svg>
  );
}
